export default __webpack_public_path__ + "static/media/Planimetria_Mattina.acd97ce3.jpg";